import { render } from "./ClientDetailsView.vue?vue&type=template&id=27f87860&scoped=true&ts=true"
import script from "./ClientDetailsView.vue?vue&type=script&lang=ts"
export * from "./ClientDetailsView.vue?vue&type=script&lang=ts"

import "./ClientDetailsView.vue?vue&type=style&index=0&id=27f87860&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f87860"]])

export default __exports__